import React from "react"
import { css } from "@emotion/core"
import { Filter } from "react-feather"

const icon = css`
  margin-left: 10px;
  margin-right: 10px;
  stroke: var(--color-interactive-dark);
  &:hover {
    fill: var(--color-interactive-dark);
    cursor: pointer;
  },
`

const FilterToggle = ({ checked, setChecked }) => {
  return (
    <button
      aria-label="Filter Blog Posts"
      css={css`
        display: inline-block;
        width: 40px;
        height: 35px;
        float: right;
        & svg {
          fill: ${checked ? "var(--color-interactive-dark)" : "none"};
        }
      `}
      onClick={ev => {
        setChecked(!checked)
        //   checked: !state.checked,
        //   filteredData: state.filteredData,
        //   query: state.query
        // })
      }}
    >
      <Filter css={icon} size={30} strokeWidth={2.8} />
    </button>
  )
}

export default FilterToggle
